"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AES_GCM = void 0;
const algoTypes_1 = require("./algoTypes");
class AES_GCM {
    algo;
    type = algoTypes_1.AlgoTypes.aes_gcm;
    iv;
    tag;
    derivation;
    encrypt;
    decrypt;
}
exports.AES_GCM = AES_GCM;
//# sourceMappingURL=aes_gcm.js.map